import React from "react";
import { Text, View, Image } from "@react-pdf/renderer";
import PrintApplicationStyles from "../PrintApplicationStyles";
import { formatPrintDate } from "../formatPrintDate";

const PrintSection10 = ({ section10 }) => {
  return (
    <>
      <Text break style={PrintApplicationStyles.sectionheader}>
        Section 10 – Unemployment Details
      </Text>

      {/* OLD STRUCTURE SUPPORT */}
      {section10?.hasUnemploymentGaps !== undefined && (
        <>
          <Text style={PrintApplicationStyles.subcontent}>
            10.01 Employment Gaps (Old Structure)
          </Text>
          <View style={PrintApplicationStyles.tableRow}>
            <View style={PrintApplicationStyles.inputSection}>
              <View style={PrintApplicationStyles.inputRow}>
                <Text style={PrintApplicationStyles.inputLabel}>
                  Have you had any periods of unemployment of more than one month in
                  the last five years?
                </Text>
                <View style={PrintApplicationStyles.inputBox}>
                  <Text>
                    {section10?.hasUnemploymentGaps === true
                      ? "Yes"
                      : section10?.hasUnemploymentGaps === false
                        ? "No"
                        : section10?.hasUnemploymentGaps === "N/A"
                          ? "Not Applicable"
                          : ""}
                  </Text>
                </View>
              </View>
            </View>
          </View>

          {section10?.unemploymentPeriods &&
            section10.unemploymentPeriods.length > 0 && (
              <>
                <View style={PrintApplicationStyles.tableHeader}>
                  <Text style={{ ...PrintApplicationStyles.tableCell, flex: 2 }}>
                    From Date
                  </Text>
                  <Text style={{ ...PrintApplicationStyles.tableCell, flex: 2 }}>
                    To Date
                  </Text>
                  <Text style={{ ...PrintApplicationStyles.tableCell, flex: 3 }}>
                    Reason for Unemployment
                  </Text>
                </View>
                {section10.unemploymentPeriods.map((period, index) => (
                  <View key={index} style={PrintApplicationStyles.tableRow}>
                    <Text style={{ ...PrintApplicationStyles.tableCell, flex: 2 }}>
                      {formatPrintDate(period.fromDate)}
                    </Text>
                    <Text style={{ ...PrintApplicationStyles.tableCell, flex: 2 }}>
                      {formatPrintDate(period.toDate)}
                    </Text>
                    <Text style={{ ...PrintApplicationStyles.tableCell, flex: 3 }}>
                      {period.reason || ""}
                    </Text>
                  </View>
                ))}
              </>
            )}

          <Text style={PrintApplicationStyles.subcontent}>
            10.02 Benefit Claims (Old Structure)
          </Text>
          <View style={PrintApplicationStyles.tableRow}>
            <View style={PrintApplicationStyles.inputSection}>
              <View style={PrintApplicationStyles.inputRow}>
                <Text style={PrintApplicationStyles.inputLabel}>
                  Have you claimed any benefits (such as Jobseeker's Allowance,
                  Employment and Support Allowance, or other DWP benefits) in the
                  last five years?
                </Text>
                <View style={PrintApplicationStyles.inputBox}>
                  <Text>
                    {section10?.claimedBenefits === true
                      ? "Yes"
                      : section10?.claimedBenefits === false
                        ? "No"
                        : section10?.claimedBenefits === "N/A"
                          ? "Not Applicable"
                          : ""}
                  </Text>
                </View>
              </View>
            </View>
          </View>

          {section10?.benefitClaims && section10.benefitClaims.length > 0 && (
            <>
              <View style={PrintApplicationStyles.tableHeader}>
                <Text style={{ ...PrintApplicationStyles.tableCell, flex: 2 }}>
                  Benefit Type
                </Text>
                <Text style={{ ...PrintApplicationStyles.tableCell, flex: 2 }}>
                  From Date
                </Text>
                <Text style={{ ...PrintApplicationStyles.tableCell, flex: 2 }}>
                  To Date
                </Text>
              </View>
              {section10.benefitClaims.map((claim, index) => (
                <View key={index} style={PrintApplicationStyles.tableRow}>
                  <Text style={{ ...PrintApplicationStyles.tableCell, flex: 2 }}>
                    {claim.benefitType || ""}
                  </Text>
                  <Text style={{ ...PrintApplicationStyles.tableCell, flex: 2 }}>
                    {formatPrintDate(claim.fromDate)}
                  </Text>
                  <Text style={{ ...PrintApplicationStyles.tableCell, flex: 2 }}>
                    {formatPrintDate(claim.toDate)}
                  </Text>
                </View>
              ))}
            </>
          )}

          <Text style={PrintApplicationStyles.subcontent}>
            10.03 DWP Office Details (Old Structure)
          </Text>
          <View style={PrintApplicationStyles.tableRow}>
            <View style={PrintApplicationStyles.inputSection}>
              <View style={PrintApplicationStyles.inputRow}>
                <Text style={PrintApplicationStyles.inputLabel}>
                  Name of your local DWP office
                </Text>
                <View style={PrintApplicationStyles.inputBox}>
                  <Text>{section10?.dwpOfficeName || ""}</Text>
                </View>
              </View>
              <View style={PrintApplicationStyles.inputRow}>
                <Text style={PrintApplicationStyles.inputLabel}>
                  DWP Office Address
                </Text>
                <View style={PrintApplicationStyles.inputBox}>
                  <Text>{section10?.dwpOfficeAddress || ""}</Text>
                </View>
              </View>
              <View style={PrintApplicationStyles.inputRow}>
                <Text style={PrintApplicationStyles.inputLabel}>
                  DWP Office Phone Number
                </Text>
                <View style={PrintApplicationStyles.inputBox}>
                  <Text>{section10?.dwpOfficePhone || ""}</Text>
                </View>
              </View>
            </View>
          </View>
        </>
      )}

      {/* NEW STRUCTURE SUPPORT */}
      {section10?.unemployedOrClaimedBenefit !== undefined && (
        <>
          <Text  style={PrintApplicationStyles.subcontent}>
            10.01 Unemployment or Benefit Claims (New Structure)
          </Text>
          <View style={PrintApplicationStyles.tableRow}>
            <View style={PrintApplicationStyles.inputSection}>
              <View style={PrintApplicationStyles.inputRow}>
                <Text style={PrintApplicationStyles.inputLabel}>
                  Have you been unemployed or claiming any kind of benefit over the
                  last 3 years?
                </Text>
                <View style={PrintApplicationStyles.inputBox}>
                  <Text>
                    {section10?.unemployedOrClaimedBenefit === true
                      ? "Yes"
                      : section10?.unemployedOrClaimedBenefit === false
                        ? "No"
                        : ""}
                  </Text>
                </View>
              </View>
            </View>
          </View>

          {section10?.unemployedOrClaimedBenefit === true &&
            section10?.details &&
            section10.details.length > 0 && (
            <>
              {section10.details.map((detail, detailIndex) => (
                <View key={detailIndex}>
                <Text
                  style={PrintApplicationStyles.subcontent}
                >
                  10.02 DWP Office {detailIndex + 1}
                </Text>

                <View style={PrintApplicationStyles.tableRow}>
                  <View style={PrintApplicationStyles.inputSection}>
                    <View style={PrintApplicationStyles.inputRow}>
                      <Text style={PrintApplicationStyles.inputLabel}>
                        DWP Office Address
                      </Text>
                      <View style={PrintApplicationStyles.inputBox}>
                        <Text>{detail?.dwpOfficeAddress || ""}</Text>
                      </View>
                    </View>
                    <View style={PrintApplicationStyles.inputRow}>
                      <Text style={PrintApplicationStyles.inputLabel}>
                        DWP Office Postcode
                      </Text>
                      <View style={PrintApplicationStyles.inputBox}>
                        <Text>{detail?.dwpPostCode || ""}</Text>
                      </View>
                    </View>
                  </View>
                </View>

                <Text style={PrintApplicationStyles.subcontent}>
                  10.02.{detailIndex + 1} Claimant Details
                </Text>

                <View style={PrintApplicationStyles.tableRow}>
                  <View style={PrintApplicationStyles.inputSection}>
                    <View style={PrintApplicationStyles.inputRow}>
                      <Text style={PrintApplicationStyles.inputLabel}>
                        Name
                      </Text>
                      <View style={PrintApplicationStyles.inputBox}>
                        <Text>{detail?.name || ""}</Text>
                      </View>
                    </View>
                    <View style={PrintApplicationStyles.inputRow}>
                      <Text style={PrintApplicationStyles.inputLabel}>
                        Date of Birth
                      </Text>
                      <View style={PrintApplicationStyles.inputBox}>
                        <Text>
                          {formatPrintDate(detail?.dateOfBirth)}
                        </Text>
                      </View>
                    </View>
                    <View style={PrintApplicationStyles.inputRow}>
                      <Text style={PrintApplicationStyles.inputLabel}>
                        National Insurance Number
                      </Text>
                      <View style={PrintApplicationStyles.inputBox}>
                        <Text>{detail?.nationalInsuranceNumber || ""}</Text>
                      </View>
                    </View>
                    <View style={PrintApplicationStyles.inputRow}>
                      <Text style={PrintApplicationStyles.inputLabel}>
                        Current Address
                      </Text>
                      <View style={PrintApplicationStyles.inputBox}>
                        <Text>{detail?.currentAddress || ""}</Text>
                      </View>
                    </View>
                    <View style={PrintApplicationStyles.inputRow}>
                      <Text style={PrintApplicationStyles.inputLabel}>
                        Postcode
                      </Text>
                      <View style={PrintApplicationStyles.inputBox}>
                        <Text>{detail?.postcode || ""}</Text>
                      </View>
                    </View>
                  </View>
                </View>

                <Text style={PrintApplicationStyles.subcontent}>
                  10.02.{detailIndex + 1}.1 Benefit Claim Period
                </Text>

                <View style={PrintApplicationStyles.tableRow}>
                  <View style={PrintApplicationStyles.inputSection}>
                    <View style={PrintApplicationStyles.inputRow}>
                      <Text style={PrintApplicationStyles.inputLabel}>
                        Type of Benefit Claimed
                      </Text>
                      <View style={PrintApplicationStyles.inputBox}>
                        <Text>{detail?.benefitClaimed || ""}</Text>
                      </View>
                    </View>
                    <View style={PrintApplicationStyles.inputRow}>
                      <Text style={PrintApplicationStyles.inputLabel}>
                        From Date
                      </Text>
                      <View style={PrintApplicationStyles.inputBox}>
                        <Text>
                          {formatPrintDate(detail?.from)}
                        </Text>
                      </View>
                    </View>
                    <View style={PrintApplicationStyles.inputRow}>
                      <Text style={PrintApplicationStyles.inputLabel}>
                        To Date
                      </Text>
                      <View style={PrintApplicationStyles.inputBox}>
                        <Text>
                          {formatPrintDate(detail?.to)}
                        </Text>
                      </View>
                    </View>
                  </View>
                </View>

                {detail?.benefitDetails && detail.benefitDetails.length > 0 && (
                  <>
                    <Text style={PrintApplicationStyles.subcontent}>
                      10.02.{detailIndex + 1}.2 Benefit Details
                    </Text>

                    <View style={PrintApplicationStyles.tableHeader}>
                      <Text
                        style={{
                          ...PrintApplicationStyles.tableCell,
                          flex: 2,
                        }}
                      >
                        From Date
                      </Text>
                      <Text
                        style={{
                          ...PrintApplicationStyles.tableCell,
                          flex: 2,
                        }}
                      >
                        To Date
                      </Text>
                      <Text
                        style={{
                          ...PrintApplicationStyles.tableCell,
                          flex: 3,
                        }}
                      >
                        Type of Benefit Claimed
                      </Text>
                    </View>

                    {detail.benefitDetails.map((benefit, benefitIndex) => (
                      <View
                        key={benefitIndex}
                        style={PrintApplicationStyles.tableRow}
                      >
                        <Text
                          style={{
                            ...PrintApplicationStyles.tableCell,
                            flex: 2,
                          }}
                        >
                          {formatPrintDate(benefit?.from)}
                        </Text>
                        <Text
                          style={{
                            ...PrintApplicationStyles.tableCell,
                            flex: 2,
                          }}
                        >
                          {formatPrintDate(benefit?.to)}
                        </Text>
                        <Text
                          style={{
                            ...PrintApplicationStyles.tableCell,
                            flex: 3,
                          }}
                        >
                          {benefit?.benefitClaimed || ""}
                        </Text>
                      </View>
                    ))}
                  </>
                )}

                <Text style={PrintApplicationStyles.subcontent}>
                  10.02.{detailIndex + 1}.3 Areas of Concern
                </Text>

                <View style={PrintApplicationStyles.tableRow}>
                  <View style={PrintApplicationStyles.inputSection}>
                    <View style={PrintApplicationStyles.inputRow}>
                      <Text style={PrintApplicationStyles.inputLabel}>
                        Areas of Concern (if any)
                      </Text>
                      <View style={PrintApplicationStyles.inputBox}>
                        <Text>{detail?.areasOfConcern || ""}</Text>
                      </View>
                    </View>
                  </View>
                </View>

                {detail?.officerSignature && (
                  <View style={PrintApplicationStyles.tableRow}>
                    <View style={PrintApplicationStyles.inputSection}>
                      <View style={PrintApplicationStyles.inputRow}>
                        <Text style={PrintApplicationStyles.inputLabel}>
                          DWP Office Officer Signature
                        </Text>
                        <View style={PrintApplicationStyles.inputBox}>
                          <Image
                            src={detail.officerSignature}
                            style={{
                              width: 200,
                              height: 80,
                              marginTop: 10,
                            }}
                          />
                        </View>
                      </View>
                    </View>
                  </View>
                )}

                {detail?.advisorSignature && (
                  <View style={PrintApplicationStyles.tableRow}>
                    <View style={PrintApplicationStyles.inputSection}>
                      <View style={PrintApplicationStyles.inputRow}>
                        <Text style={PrintApplicationStyles.inputLabel}>
                          Advisor Signature
                        </Text>
                        <View style={PrintApplicationStyles.inputBox}>
                          <Image
                            src={detail.advisorSignature}
                            style={{
                              width: 200,
                              height: 80,
                              marginTop: 10,
                            }}
                          />
                        </View>
                      </View>
                    </View>
                  </View>
                )}

                <View style={PrintApplicationStyles.tableRow}>
                  <View style={PrintApplicationStyles.inputSection}>
                    <View style={PrintApplicationStyles.inputRow}>
                      <Text style={PrintApplicationStyles.inputLabel}>
                        Date
                      </Text>
                      <View style={PrintApplicationStyles.inputBox}>
                        <Text>
                          {formatPrintDate(detail?.date)}
                        </Text>
                      </View>
                    </View>
                  </View>
                </View>
              </View>
            ))}
            </>
          )}
        </>
      )}
    </>
  );
};

export default PrintSection10;
